import { createApi } from '@reduxjs/toolkit/query/react';

import {
  fetchWithAuthBaseQuery,
  validateAndTransformResponse,
} from '#shared/api';

import { newCasesResponseSchema, type NewCasesResponse } from './schemas';

const paths = {
  newCases: 'api/newCases',
} as const;

export const newCasesApi = createApi({
  reducerPath: 'newCasesApi',

  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  endpoints: build => ({
    getNewCases: build.query({
      query: () => paths.newCases,
      // Transform response to include validation without throwing
      transformResponse: (response: NewCasesResponse) =>
        validateAndTransformResponse(
          newCasesResponseSchema,
          response,
          value => value?.label,
          'newCases',
        ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetNewCasesQuery } = newCasesApi;
